module.exports = __webpack_public_path__ + "img/82.1a979ed4.png";